module.exports = __webpack_public_path__ + "static/media/development-blog-3.4a24c601.md";